import { createSlice } from '@reduxjs/toolkit';
import { PRODUCT_TYPE } from '../../define/global';
import { createSelectorFn } from './common';

const initialState = {
  clientOS: '',
  productType: PRODUCT_TYPE.NONE,
  viewAD: true,
  deviceType: undefined,
  shareId: '',
  isUnsupportDownload: false,
  extensionConnectMode: false,
  viaPartner: undefined,
  showUploadBtn: undefined
};

const appDataSlice = createSlice({
  name: 'appData',
  initialState,
  reducers: {
    setClientOS: (state, action) => {
      state.clientOS = action.payload;
    },
    setProductType: (state, action) => {
      state.productType = action.payload;
    },
    setViewAD: (state, action) => {
      state.viewAD = action.payload;
    },
    setDeviceType: (state, action) => {
      state.deviceType = action.payload;
    },
    setShareId: (state, action) => {
      state.shareId = action.payload;
    },
    setIsUnsupportDownload: (state, action) => {
      state.isUnsupportDownload = action.payload;
    },
    setExtensionConnectMode: (state, action) => {
      state.extensionConnectMode = action.payload;
    },
    setViaPartner: (state, action) => {
      state.viaPartner = action.payload;
    },
    setShowUploadBtn: (state, action) => {
      state.showUploadBtn = action.payload;
    }
  }
});

export const {
  setClientOS,
  setProductType,
  setViewAD,
  setDeviceType,
  setShareId,
  setIsUnsupportDownload,
  setExtensionConnectMode,
  setViaPartner,
  setShowUploadBtn
} = appDataSlice.actions;
export const useAppDataSliceSelector = createSelectorFn(appDataSlice);

export default appDataSlice;
